import { Component, Input, SimpleChanges } from '@angular/core';
import { ChartConfiguration, ChartOptions } from 'chart.js';
import { subMonths, startOfMonth, subDays } from 'date-fns';
import { ProfileService } from 'src/app/_services/profile.service';
import { WidgetService } from 'src/app/_services/review-services/widget.service';

@Component({
  selector: 'app-monitoring-widget',
  templateUrl: './monitoring-widget.component.html',
  styleUrls: ['./monitoring-widget.component.css']
})
export class MonitoringWidgetComponent {
  @Input() isEdit: boolean = false;
  @Input() isVisible: boolean;
  @Input() chosenUser?: string;
  @Input() selectedReviewId: number;

  monitoringTeamChartData: any;
  monitoringClientChartData: any;
  velocityTeam: number = 0;
  velocityClient: number = 0;
  chartType: ChartConfiguration['type'] = 'line';

  startDate: string;
  selectedTab: 'team' | 'client';
  endDate: string = new Date().toISOString();

  userLogged: any;

  constructor(
    private readonly widgetService: WidgetService,
    private readonly profileService: ProfileService
  ) {
    const twelveMonthsAgo: Date = subMonths(new Date(), 12);
    this.startDate = startOfMonth(twelveMonthsAgo).toISOString();
  }

  configureValideRangeForEndDate: ConfigureRangeDate = (
    current: Date
  ): boolean => {
    return new Date(this.startDate) > current || current > new Date();
  };

  configureValideRangeForStartDate: ConfigureRangeDate = (
    current: Date
  ): boolean => {
    return current > subDays(new Date(), 1);
  };

  async ngOnInit() {
    this.selectedTab = 'team';
    this.userLogged = await this.profileService.getUserRoleAsync();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.isVisible && changes['chosenUser']?.currentValue) {
      this.getMonitoringData();
    }
  }

  changeTab(tab: 'team' | 'client'): void {
    this.selectedTab = tab;
  }

  getMonitoringData() {
    const data = {
      chosen_user: this.chosenUser || this.userLogged.id,
      start_date: this.startDate,
      end_date: this.endDate,
      selectedReviewId: this.selectedReviewId
    };

    this.widgetService.getMonitoringReview(data).subscribe(data => {
      this.monitoringTeamChartData = data.team_dataset;
      this.monitoringClientChartData = data.client_dataset;
      this.velocityClient = data.velocity_client;
      this.velocityTeam = data.velocity_team;
    });
  }

  getChartOptions(): ChartOptions {
    return {
      responsive: true,
      scales: {
        x: {
          type: 'time',
          time: {
            unit: 'month',
            tooltipFormat: 'DD MMM yyyy',
            displayFormats: {
              month: 'MMM yyy'
            }
          },
          min: this.startDate, // Data odierna
          max: this.endDate // Sei mesi da oggi
        },
        y: {
          beginAtZero: true
        }
      },
      plugins: {
        tooltip: {
          callbacks: {
            label: function (tooltipItem): string {
              // Estraggo i valori da tooltipItem
              // @ts-ignore
              const yValue = tooltipItem.raw.y;
              // @ts-ignore
              const ysValue = tooltipItem.raw.yS; // Sostituisci con il valore che vuoi mostrare

              return !ysValue
                ? `V-Personale: ${yValue}`
                : `V-Personale: ${yValue}, V-Sprint: ${ysValue}`;
            }
          }
        },
        legend: {
          position: 'right',
          align: 'start',
          labels: {
            font: {
              size: 14
            },
            padding: 15,
            usePointStyle: true, // Usa le icone rotonde
            pointStyle: 'circle'
          }
        }
      }
    };
  }
}

type ConfigureRangeDate = (current: Date) => boolean;
